<script>
import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage.scss';
import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage-list.scss';
import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage-program.scss';
import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage-programs.scss';
import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage-about.scss';
import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage-partner.scss';
import '/local/templates/redesign/src/assets/scss/pages/mortgage/service-mortgage.scss';
import '/local/templates/redesign/src/assets/scss/pages/promo/mortgage-it.scss';
import '/local/templates/redesign/src/assets/scss/block/mortgage-calculator.scss';
import '/local/templates/redesign/src/assets/scss/block/mortgage-mini-calculator.scss';
import '/local/templates/redesign/src/assets/scss/pages/blog-articles.scss';
import '/local/templates/redesign/src/assets/scss/pages/blog.scss';
import MortgageList from '../components-manual/mortgage/MortgageList.vue';
import MortgageCalculator from '../components-manual/mortgage/MortgageCalculator.vue';
import MortgageCalculatorDfoption from '../components-manual/mortgage/calculator/MortgageCalculatorDfoption.vue';
import MortgageCalculatorGoalmobile from '../components-manual/mortgage/calculator/MortgageCalculatorGoalmobile.vue';
import MortgageCalculatorPfr from '../components-manual/mortgage/calculator/MortgageCalculatorPfr.vue';
import MortgageCalculatorResults from '../components-manual/mortgage/calculator/MortgageCalculatorResults.vue';
import MortgageCalculatorSlider from '../components-manual/mortgage/calculator/MortgageCalculatorSlider.vue';
import MortgageCalculatorTabs from '../components-manual/mortgage/calculator/MortgageCalculatorTabs.vue';
import callbackFormCardMortgage from '../components-manual/mortgage/callbackFormCardMortgage.vue';
import ItMortgageInn from '../components-manual/mortgage/ItMortgageInn.vue';
import MortgageAccordeon from '../components-manual/mortgage/MortgageAccordeon.vue';
import MortgageBondForm from '../components-manual/mortgage/MortgageBondForm.vue';
import MortgageContractsForm from '../components-manual/mortgage/MortgageContractsForm.vue';
import MortgageCalculatorNew from '../components-manual/mortgage/MortgageCalculatorNew.vue';
import MortgageDocumentsForm from '../components-manual/mortgage/MortgageDocumentsForm.vue';
import mortgageInsuranceCalculator from '../components-manual/mortgage/mortgageInsuranceCalculator.vue';
import mortgageOkvedChecker from '../components-manual/mortgage/mortgageOkvedChecker.vue';
import MortgageDevelopersRegion from '../components-manual/mortgage/developers/MortgageDevelopersRegion.vue';
import Hotline from '../components-manual/block/Hotline.vue';
import ArticlesRedesign from '../components-manual/mortgage/ArticlesRedesign.vue';
import MortgageRegions from '../components-manual/mortgage/MortgageRegions.vue';
import { DButton, ESize, EColor } from '@ahml/domrfbank-ui/elements/DButton';
import { scrollToElem } from '/local/templates/redesign/src/assets/js/utils';

export default {
    components: {
        MortgageList,
        MortgageCalculator,
        MortgageCalculatorDfoption,
        MortgageCalculatorGoalmobile,
        MortgageCalculatorPfr,
        MortgageCalculatorResults,
        MortgageCalculatorSlider,
        MortgageCalculatorTabs,
        callbackFormCardMortgage,
        ItMortgageInn,
        MortgageAccordeon,
        MortgageBondForm,
        MortgageContractsForm,
        MortgageCalculatorNew,
        MortgageDocumentsForm,
        mortgageInsuranceCalculator,
        mortgageOkvedChecker,
        MortgageDevelopersRegion,
        Hotline,
        ArticlesRedesign,
        MortgageRegions,
        DButton
    },
    data() {
        return {
            ESize,
            EColor
        }
    },
    methods: {
        scrollToElem(elem) {
            scrollToElem(elem)
        }
    }
};
</script>
